export default __webpack_public_path__ + "static/media/card01.141056f8.svg";